export function extractErrorMessage(error: unknown) {
    if(error instanceof Error) {
        return error.message;
    } else {
        return ""
    }
}